import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import AvailableRule from "../../../../components/available-rule";
import CurrentRule from "../../../../components/current-rule";
import { EditRuleSetState } from "../hooks/use-edit-ruleset";

type EditRuleSetRulesProps = {
  state: EditRuleSetState;
};

const EditRuleSetRules = (props: EditRuleSetRulesProps) => {
  const editRulesetState: EditRuleSetState = props.state;
  return (
    <div className="absolute inset-0 bottom-8 top-[22rem] md:top-[16rem] overflow-y-hidden">
      <div className="absolute inset-0 flex flex-col mx-8 overflow-y-hidden md:mx-36">
        <div className="absolute inset-0 grid flex-grow grid-cols-2 gap-8 pt-8 overflow-y-hidden border-t">
          <div
            ref={editRulesetState.drop}
            className="relative col-start-1 col-end-1 pb-5 overflow-y-hidden"
          >
            <label className="text-sm tracking-[0.07rem]">BUILD RULE SET</label>
            <div className="absolute inset-0 p-6 overflow-y-auto bg-blue-100 border border-dashed rounded-md border-primary-blue top-8">
              {editRulesetState.currentRules &&
                editRulesetState.currentRules.length > 0 &&
                editRulesetState.currentRules.map((rule, index) => {
                  return (
                    <div className="mb-2" key={`current-${index}`}>
                      <CurrentRule
                        index={index}
                        rule={rule}
                        moveRule={editRulesetState.moveRule}
                        deleteRule={editRulesetState.deleteRule}
                      />
                    </div>
                  );
                })}
              {(!editRulesetState.currentRules ||
                editRulesetState.currentRules.length <= 0) && (
                  <div className="absolute inset-0 flex flex-col items-center justify-center">
                    <div className="flex-grow flex flex-col p-4 text-center items-center justify-center tracking-[0.07rem]">
                      Drag and drop available rules to build a rule set.
                    </div>
                  </div>
                )}
            </div>
          </div>
          <div className="relative col-start-2 col-end-2 overflow-y-hidden ">
            <label className="text-sm tracking-[0.07rem]">
              Available Rules
            </label>
            <div className="container w-full mx-auto">
              <div className="container flex items-center gap-2 px-6 mx-auto mt-2 mb-6 bg-white border rounded border-primary-blue">
                <MagnifyingGlassIcon className="w-8 h-8 text-gray-500" />
                <input
                  key="search-input"
                  className="w-full m-2 text-lg outline-none"
                  placeholder="Search available rules"
                  value={editRulesetState.ruleSearch}
                  onChange={(e) =>
                    editRulesetState.updateRuleSearch(e.target.value)
                  }
                ></input>
              </div>
            </div>
            <div className="absolute inset-0 grid gap-2 px-1 overflow-y-auto top-24 md:grid-cols-2 auto-rows-min">
              {editRulesetState.filteredRules &&
                editRulesetState.filteredRules.map((rule, index) => {
                  return (
                    <div key={`available-${rule.id}`}>
                      <AvailableRule
                        rule={rule}
                        index={index}
                        addRule={editRulesetState.addRule}
                      />
                    </div>
                  );
                })}
              {editRulesetState.filteredRules &&
                editRulesetState.filteredRules.length === 0 &&
                editRulesetState.ruleSearch && (
                  <div className="col-span-2 text-center">
                    No rules matching{" "}
                    <span className="font-semibold">
                      {editRulesetState.ruleSearch}
                    </span>
                    .
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRuleSetRules;
